export default [
  'TERMS_AND_CONDITIONS',
  'PRIVACY_POLICY',
];
